import { PLATFORM_TENANT_SLUG } from "@/constants/platform";
import { platformLandingProfile } from "@/data/public/landingProfile";

export type LandingProfileMock = {
  imageUrl?: string;
  imageAlt?: string;
  analyticsPrefix: string;
};

const defaultTenantLandingProfile: LandingProfileMock = {
  analyticsPrefix: "",
};

/**
 * Resolves landing profile mock for a tenant slug
 */
export const getLandingProfileMock = (
  slug: string,
  isPlatform = false,
): LandingProfileMock => {
  if (isPlatform || slug === PLATFORM_TENANT_SLUG) {
    return platformLandingProfile;
  }

  return {
    ...defaultTenantLandingProfile,
    analyticsPrefix: slug,
  };
};
